import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasGas = createSelector(selectJsonQuery, jsonQuery => getTermValue('gas')(jsonQuery));
